<template>
	<article
		:id="id"
		:class="[labelClass, 'dc-post-grid-card', 'post-card']"
		v-on:click.meta.stop.prevent="goToPost('cmdCtrl')"
		v-on:click.ctrl.stop.prevent="goToPost('cmdCtrl')"
		v-on:click.exact.stop.prevent="goToPost('click')"
	>
		<div
			:class="[
				'card-image',
				{
					'no-image': !image,
				},
			]"
		>
			<img v-if="image" :src="image.src" :srcset="image.srcset" :alt="image.alt" />
		</div>
		<div ref="cardContentWrapper" class="card-content">
			<div>
				<span class="card-date" v-if="date">{{ date }}</span>
				<h3 v-if="title" class="card-title">{{ title }}</h3>
				<p v-if="excerpt" class="card-excerpt">{{ excerpt }}</p>
			</div>
			<dc-button :url="url" :aria-label="`Read article: ${title}`" />
		</div>
	</article>
</template>

<script>
import DcButton from '../ui/DcButton';
export default {
	props: {
		id: {
			type: String | Number,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		url: {
			type: String,
			required: true,
		},
		excerpt: {
			type: String,
			required: false,
		},
		label: {
			type: Object,
			required: false,
		},
		image: {
			type: Object,
			required: false,
		},
		date: {
			type: String,
			required: false,
		},
		suptitle: {
			type: String,
			required: false,
		},
	},
	computed: {
		labelClass() {
			if (typeof this.label === 'undefined' || typeof this.label.class === 'undefined')
				return '';
			return this.label.class;
		},
	},
	methods: {
		goToPost(type) {
			if (type === 'cmdCtrl') {
				window.open(this.url);
			} else {
				window.location.href = this.url;
			}
		},
	},
	components: {
		DcButton,
	},
};
</script>
